import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";
import Loading from "../Components/Loading";
import Table from "../Components/Assets/Table";
import { toast } from "react-toastify";
import {
  BoxTitle,
  BoxContainer,
  Underline,
  BoxHead,
  FilterTableWrapper,
} from "../Components/Styles/PageStyles";
import NotFoundModel from "../Components/NotFoundModel";
import { useSelector } from "react-redux";
import BaseForm from "../Components/Assets/BaseForm";
import ViewDetails from "../Components/Assets/ViewDetails";
import AddVendor from "../Components/Expenses/AddVendor";
import AssignmentDetails from "../Components/Assets/AssignmentDetails";
import EditBasicDetail from "../Components/Assets/EditBasicDetail";
import EditAssignmentDetails from "../Components/Assets/EditAssignmentDetails";
import MaintenanceDetail from "../Components/Assets/MaintenanceDetail";
import FilterScreen from "../Components/Assets/FilterScreen";
import SideModal from "../Components/SideModal";
import DeleteAsset from "../Components/Assets/DeleteAsset";
import AddAlertModal from "../Components/Assets/AddAlertModal";

const Assets = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const propertyList = useSelector((state) => state.PropertyReducer.property);
  const [selectedData, setSelectedData] = useState("");
  const [selectedProperty, setSelectedProperty] = useState("");
  const [isAssignmentDetails, setIsAssignmentDetails] = useState(false);
  const [isDeleteAsset, setIsDeleteAsset] = useState(false);
  const [isEditAssignmentDetails, setIsEditAssignmentDetails] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);
  const [editBasicDetail, setEditBasicDetail] = useState(false);
  const [isAddAssetModal, setIsAddAssetModal] = useState(false);
  const [isAddVendor, setIsAddVendor] = useState(false);
  const [isMaintenanceDetails, setIsMaintenanceDetails] = useState(false);
  const [showAddVendorForm, setShowAddVendorForm] = useState(false);
  const [expenseData, setExpenseData] = useState([]);
  const [selectedPropertyAssets, setSelectedPropertyAssets] = useState([]);
  const [apiData, setApiData] = useState();
  const [staffList, setStaffList] = useState();
  const [vendorName, setVendorName] = useState("");
  const [vendorMobile, setVendorMobile] = useState("");
  const [activeFilter, setActiveFilter] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [formData, setFormData] = useState({
    basicDetails: "",
    purchaseDetails: "",
    supportingDocument: "",
  });
  const [addAlertDetail, setAddAlertDetail] = useState(false);
  const [editAlertData, setEditAlertData] = useState("");

  const fetchInitData = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/expense/initial-values`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    setExpenseData(response.data.data);
  };

  const fetchFunction = async () => {
    let url = `${Config.apiUrl}/asset/list`;

    if (activeFilter && activeFilter.filter && activeFilter.filterVal) {
      url = `${url}?filter=${activeFilter.filter}&filterVal=${activeFilter.filterVal}`;
    }
    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      setStaffList(res?.staffList);

      fetchInitData();
    }
  };

  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const handleFilterChange = (filterData) => {
    setActiveFilter(filterData);
    setFiltersApplied(true);
    setTimeout(() => {
      getListMutate();
    }, 100);
  };

  const handleResetFilters = () => {
    if (filtersApplied) {
      handleFilterChange(null);
      setFiltersApplied(false);
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  // Add Asset Function
  const addAssetFunction = async (values) => {
    const body = new FormData();
    body.append("type", Number(values.basicDetails.assetType));
    body.append("name", values.basicDetails.assetSubType);
    body.append("count", Number(values.basicDetails.quantity));
    body.append("vehicleNum", values.basicDetails.vehicleNum);
    body.append("description", values.basicDetails.description || "");
    body.append("purchaseDate", values.purchaseDetails.purchaseDate);
    body.append("cost", Number(values.purchaseDetails.purchasePrice));
    body.append("status", 1);
    body.append("depreciationRate", values.purchaseDetails.depreciation || "");
    body.append("vendorId", values.purchaseDetails.assignVendor);
    body.append("warrentyExpire", values.purchaseDetails.warrentyExpire || "");
    Object.values(values.supportingDocument).forEach((file) => {
      if (file) {
        body.append("files", file);
      }
    });

    return await axios.post(`${Config.apiUrl}/asset/add`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const addAssetFunctionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Asset data successfully Updated.");
      setIsAddAssetModal(false);
      getListMutate();
    }
  };

  const addAssetFunctionError = (res) => {
    toast.error(res?.response?.data?.msg || "An error occured");
  };

  const { isLoading: isaddAssetLoading, mutate: addAssetFunctionMutate } =
    useMutation(addAssetFunction, {
      onSuccess: addAssetFunctionSuccess,
      onError: addAssetFunctionError,
    });

  //------- Add vendor -------
  const addVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setShowAddVendorForm(false);
      setVendorMobile("");
      setVendorName("");
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddVendorError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: addVendorLoading,
    mutate: addVendorMutate,
    data: vendorList,
  } = useMutation(addVendorFunction, {
    onSuccess: onAddVendorSuccess,
    onError: onAddVendorError,
  });

  const handleAddVendorClose = () => {
    setIsAddVendor(false);
    setSelectedData("2");
  };

  const handleMaintenanceClose = () => {
    setIsMaintenanceDetails(false);
    setShowAddVendorForm(false);
    setVendorMobile("");
    setVendorName("");
  };
  const handleVendorFormClose = () => {
    setShowAddVendorForm(false);
    setVendorMobile("");
    setVendorName("");
  };
  //------- Assign Property -------
  const assignPropertyFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/asset/assign/property`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const assignPropertySuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAssignmentDetails(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const assignPropertyError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: assignPropertyLoading, mutate: assignPropertyMutate } =
    useMutation(assignPropertyFunction, {
      onSuccess: assignPropertySuccess,
      onError: assignPropertyError,
    });

  //------- Edit Assign Property -------
  const editAssignPropertyFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/asset/edit/assignment/details`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const editAssignPropertySuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsEditAssignmentDetails(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const editAssignPropertyError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: editAssignPropertyLoading,
    mutate: editAssignPropertyMutate,
  } = useMutation(editAssignPropertyFunction, {
    onSuccess: editAssignPropertySuccess,
    onError: editAssignPropertyError,
  });

  //------- Edit Basic Detail -------
  const editBasicDetailFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/asset/edit/basic/details`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const editBasicDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditBasicDetail(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const editBasicDetailError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editBasicDetailLoading, mutate: editBasicDetailMutate } =
    useMutation(editBasicDetailFunction, {
      onSuccess: editBasicDetailSuccess,
      onError: editBasicDetailError,
    });

  //------- MaintenanceDetail -------
  const maintenanceDetailFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/asset/maintenance/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const maintenanceDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsMaintenanceDetails(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const maintenanceDetailError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: maintenanceDetailLoading,
    mutate: maintenanceDetailMutate,
  } = useMutation(maintenanceDetailFunction, {
    onSuccess: maintenanceDetailSuccess,
    onError: maintenanceDetailError,
  });
  //------- Delete Asset  -------
  const deleteAssetFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/asset/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteAssetSuccess = (data) => {
    setIsDeleteAsset(false);
    setViewDetail(false)
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const deleteAssetError = (data) => {
    setIsDeleteAsset(false);
    setViewDetail(false)
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteAssetLoading, mutate: deleteAssetMutate } =
    useMutation(deleteAssetFunction, {
      onSuccess: deleteAssetSuccess,
      onError: deleteAssetError,
    });

  //------- Add Alert Detail -------
  const addAlertDetailFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/asset/update/asset/info`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const addAlertDetailSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setAddAlertDetail(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const addAlertDetailError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addAlertDetailLoading, mutate: addAlertDetailMutate } =
    useMutation(addAlertDetailFunction, {
      onSuccess: addAlertDetailSuccess,
      onError: addAlertDetailError,
    });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Assets
          <Underline />
        </BoxTitle>
        <AddBtn type="button" onClick={() => setIsAddAssetModal(true)}>
          {"Add Asset"}
        </AddBtn>
      </BoxHead>

      <SideModal
        isOpen={isAddAssetModal}
        onClose={() => setIsAddAssetModal(false)}
      >
        <BaseForm
          setIsAddAssetModal={setIsAddAssetModal}
          addAssetFunctionMutate={addAssetFunctionMutate}
          isaddAssetLoading={isaddAssetLoading}
          setFormData={setFormData}
          formData={formData}
          vendorList={vendorList?.data?.vendors}
          expenseData={expenseData}
          setIsAddVendor={setIsAddVendor}
          selectedData={selectedData}
          showAddVendorForm={showAddVendorForm}
          setShowAddVendorForm={setShowAddVendorForm}
          addVendorMutate={addVendorMutate}
          addVendorLoading={addVendorLoading}
          vendorName={vendorName}
          setVendorName={setVendorName}
          vendorMobile={vendorMobile}
          setVendorMobile={setVendorMobile}
          handleMaintenanceClose={handleMaintenanceClose}
          handleVendorFormClose={handleVendorFormClose}
        />
      </SideModal>

      <SideModal isOpen={isAddVendor} onClose={() => setIsAddVendor(false)}>
        <AddVendor
          addVendorMutate={addVendorMutate}
          addVendorLoading={addVendorLoading}
          handleClose={handleAddVendorClose}
        />
      </SideModal>

      <SideModal
        isOpen={isAssignmentDetails}
        onClose={() => setIsAssignmentDetails(false)}
      >
        <AssignmentDetails
          setIsAssignmentDetails={setIsAssignmentDetails}
          assignPropertyMutate={assignPropertyMutate}
          assignPropertyLoading={assignPropertyLoading}
          property={propertyList}
          selectedData={selectedData}
          staffList={staffList}
        />
      </SideModal>

      <SideModal
        isOpen={isMaintenanceDetails}
        onClose={() => setIsMaintenanceDetails(false)}
      >
        <MaintenanceDetail
          setIsMaintenanceDetails={setIsMaintenanceDetails}
          maintenanceDetailMutate={maintenanceDetailMutate}
          maintenanceDetailLoading={maintenanceDetailLoading}
          selectedData={selectedData}
          vendorList={vendorList?.data?.vendors}
          showAddVendorForm={showAddVendorForm}
          setShowAddVendorForm={setShowAddVendorForm}
          expenseData={expenseData}
          addVendorMutate={addVendorMutate}
          addVendorLoading={addVendorLoading}
          vendorName={vendorName}
          setVendorName={setVendorName}
          vendorMobile={vendorMobile}
          setVendorMobile={setVendorMobile}
          handleMaintenanceClose={handleMaintenanceClose}
          handleVendorFormClose={handleVendorFormClose}
          selectedProperty={selectedProperty}
        />
      </SideModal>

      <SideModal
        isOpen={isEditAssignmentDetails}
        onClose={() => setIsEditAssignmentDetails(false)}
      >
        <EditAssignmentDetails
          setIsEditAssignmentDetails={setIsEditAssignmentDetails}
          editAssignPropertyMutate={editAssignPropertyMutate}
          editAssignPropertyLoading={editAssignPropertyLoading}
          property={propertyList}
          selectedData={selectedData}
          selectedPropertyAssets={selectedPropertyAssets}
          selectedProperty={selectedProperty}
          staffList={staffList}
        />
      </SideModal>

      <SideModal
        isOpen={editBasicDetail}
        onClose={() => setEditBasicDetail(false)}
      >
        <EditBasicDetail
          setEditBasicDetail={setEditBasicDetail}
          editBasicDetailMutate={editBasicDetailMutate}
          editBasicDetailLoading={editBasicDetailLoading}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={addAlertDetail}
        onClose={() => setAddAlertDetail(false)}
      >
        <AddAlertModal
          setAddAlertDetail={setAddAlertDetail}
          addAlertDetailMutate={addAlertDetailMutate}
          addAlertDetailLoading={addAlertDetailLoading}
          selectedData={selectedData}
          editAlertData={editAlertData}
        />
      </SideModal>


      <SideModal isOpen={viewDetail} onClose={() => setViewDetail(false)}>
        <ViewDetails
          setViewDetail={setViewDetail}
          setSelectedData={setSelectedData}
          selectedData={selectedData}
          setEditBasicDetail={setEditBasicDetail}
          setIsAssignmentDetails={setIsAssignmentDetails}
          setIsDeleteAsset={setIsDeleteAsset}
          setAddAlertDetail={setAddAlertDetail}
          setEditAlertData={setEditAlertData}
        />
      </SideModal>
      {isDeleteAsset && (
        <DeleteAsset
          isDeleteAsset={isDeleteAsset}
          setIsDeleteAsset={setIsDeleteAsset}
          deleteAssetLoading={deleteAssetLoading}
          deleteAssetMutate={deleteAssetMutate}
          selectedData={selectedData}
        />
      )}
      <FilterTableWrapper>
        <FilterScreen
          vendors={expenseData?.vendors || []}
          onFilterChange={handleFilterChange}
          onResetFilters={handleResetFilters}
          filtersApplied={filtersApplied}
        />
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setViewDetail={setViewDetail}
              setIsAssignmentDetails={setIsAssignmentDetails}
              setIsEditAssignmentDetails={setIsEditAssignmentDetails}
              selectedPropertyAssets={selectedPropertyAssets}
              setSelectedPropertyAssets={setSelectedPropertyAssets}
              selectedProperty={selectedProperty}
              setSelectedProperty={setSelectedProperty}
              setIsMaintenanceDetails={setIsMaintenanceDetails}
            />
            {apiData.length === 0 && !isLoading && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {error && !isLoading && <NotFoundModel />}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md `;
const UploadWrapper = tw.div`flex items-center gap-3 `;
const Button = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;

export default Assets;
